MonRgpd = {
    name: {
        perso: "rgpd__v2__perso__",
        pub: "rgpd__v2__pub__",
        stats: "rgpd__v2__stats__",
    },
    info: "rgpd__v2__info__",
    delay: '13m',
    interval:100,
    link:{
        'custom':'/cookies',
        'about':'/mentions-legales'
    }
}
